import * as commonTypes from './commonActionTypes';
import { updateObject, createDeepCopy } from 'src/services/functions';

const initialState = {
  backUrl: null,
  campusesList: null,
  commonFilters: {
    campusId: null,
    practitionerId: null
  },
  practitionersList: null
};

export default (state = initialState, action) => {
  switch (action.type) {    
    case commonTypes.SET_BACK_URL: {
      return { ...state, backUrl: action.payload };
    }
    case commonTypes.RESET_BACK_URL: {
      return { ...state, backUrl: null };
    }
    case commonTypes.SET_CAMPUSES_LIST: {
      return { ...state, campusesList: action.payload };
    }
    case commonTypes.UPDATE_COMMON_FILTERS: {
      const tFilters = updateObject(createDeepCopy(state.commonFilters), action.payload);
      return {
        ...state,
        commonFilters: tFilters
      };
    }
    case commonTypes.SET_PRACTITIONERS_LIST: {
      return { ...state, practitionersList: action.payload };
    }
    default:
      return state;
  }
};
